import Textfield from './Textfield';
import { TextfieldProps } from './Textfield.types';

export default Textfield;

export type { TextfieldProps };
